import * as React from 'react';
import {useState} from 'react';
import {CardsFilters} from "./CardFilters";
import {Pagination} from "../../../partials/Pagination";
import {CardObject, useCardsCountersQuery, useCardsListQuery, useGetAllowedCoursesQuery} from "../../../../types.d";
import {VocabularyThumb} from "./VocabularyThumb";
import {Route, RouteComponentProps} from "react-router";
import {CardTypeId} from "../../../../utils/constants";
import {ExerciseThumb} from "./ExerciseThumb";
import {LanguageFilter} from "../../../partials/LanguageFilter";
import {MnemoThumb} from "./MnemoThumb";
import {Link} from "react-router-dom";

interface VocabularyCardsPageProps extends RouteComponentProps<{ userId? }> {
}

export const VocabularyCardsPage = (props: VocabularyCardsPageProps) => {
    const [search, setSearch] = useState<string>(null);
    const [language, setLanguage] = useState<number>(null);
    const basePath = props.match.url;
    const userId = Number(props.match.params.userId);

    const allowedCourses = useGetAllowedCoursesQuery({
        variables: {
            userId
        }
    });

    let type;
    let title;

    if (basePath.includes('vocabulary')) {
        type = 'lp';
        title = 'Vocabulary Cards';
    }

    if (basePath.includes('mnemo')) {
        type = 'mc';
        title = 'Mnemo Cards';
    }

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        { title }
                    </li>
                </ol>
            </nav>

            <div className={'row mx mb-2'}>
                <div className={'col-3'}>
                    { allowedCourses.data && (
                        <LanguageFilter
                            filter={(language) => {
                                return allowedCourses.data.allowedCourses.filter(item => item.sourceLanguage.id === language.id).length
                            }}
                            onChange={(id) => {
                                setLanguage(id);
                                props.history.push(`${basePath}/${id}/${type}_created/0`)
                            }}
                        />
                    ) }
                </div>
                <div className="col-3">
                    { language && (
                        <div className="input-group mb-3 cards-search">
                            <input
                                type="search"
                                name="find"
                                className="form-control"
                                onChange={e => setSearch(e.currentTarget.value)}
                                placeholder="Search" />
                            <div className="input-group-append">
                                <button
                                    onClick={() => props.history.push(`${basePath}/${language}/${type}_created/0/${search}`)}
                                    className="btn btn-outline-secondary"
                                    type="button">Search</button>
                            </div>
                        </div>
                    ) }
                </div>
            </div>

            <Route
                path={`${basePath}/:language/:type/:offset/:search?`}
                render={props => <VocabularyCardsRoute type={type} basePath={basePath} {...props} />} />
        </div>
    </div>
};

interface VocabularyCardsRouteProps extends RouteComponentProps<{
    offset,
    type,
    search?
    language,
    userId?
}> {
    type: string;
    basePath: string;
}

export const VocabularyCardsRoute = (props: VocabularyCardsRouteProps) => {
    const userId = Number(props.match.params.userId);
    const language = Number(props.match.params.language);
    const type = props.match.params.type;
    const search = props.match.params.search || '';
    const limit = 12;

    const types = {
        created: `${props.type}_created`,
        rejected: `${props.type}_rejected`,
        pending: `${props.type}_pending`,
        pendingEscalation: `${props.type}_pending_escalation`,
        reviewed: `${props.type}_reviewed`,
        escalated: `${props.type}_escalated`
    };

    const cards = useCardsListQuery({
        fetchPolicy: 'network-only',
        variables: {
            search: props.match.params.search,
            userId,
            languageId: language,
            limit,
            offset: Number(props.match.params.offset),
            type
        }
    });

    const counters = useCardsCountersQuery({
        skip: !cards.data,
        fetchPolicy: 'network-only',
        variables: {
            userId: null,
            languageId: language,
            createdType: types.created,
            rejectedType: types.rejected,
            pendingType: types.pending,
            pendingEscalationType: types.pendingEscalation,
            reviewedType: types.reviewed,
            escalatedType: types.escalated,
        }
    });

    const url = (type: string) => `${props.basePath}/${language}/${props.type}_${type}/0/${search}`;
    const pageUrl = (page: number) => `${props.basePath}/${language}/${type}/${page}/${search}`;

    return <>
        { counters.data && (
            <CardsFilters
                items={[
                    { title: 'Created', counter: counters.data.created.count, link: url(`created`), active: true },
                    { title: 'Rejected', counter: counters.data.rejected.count, link: url(`rejected`) },
                    { title: 'Under Review', counter: counters.data.pending.count, link: url(`pending`) },
                    { title: 'Pending Escalation', counter: counters.data.pendingEscalation.count, link: url(`pending_escalation`) },
                ]} />
        ) }

        { cards.data && <div className={'mt-5'}>
            <Pagination
                limit={limit}
                offset={Number(props.match.params.offset)}
                count={Number(cards.data.cardsList.count)}
                url={pageUrl} />
        </div> }

        <div className={'row d-flex pt-4 pb-5 mx-2'}>
            { cards.loading ? <h3 className={'text-center'}>Loading...</h3> : (
                cards.data.cardsList.cards.filter(c => props.type !== 'mc' || c.mnemo).map(item => {
                    if (props.type === 'mc') {
                        return <MnemoThumb card={item as CardObject} />
                    }

                    return item.cardType === CardTypeId.Vocabulary ? (
                        <VocabularyThumb
                            key={item.id}
                            card={item as CardObject} />
                    ) : (
                        <ExerciseThumb
                            key={item.id}
                            card={item as CardObject} />
                    )
                })
            ) }
        </div>

        { cards.data && <Pagination
            limit={limit}
            offset={Number(props.match.params.offset)}
            count={Number(cards.data.cardsList.count)}
            url={pageUrl} /> }
    </>
};
